import {Component, computed, input, signal} from '@angular/core';

@Component({
  selector: 'app-chars-left',
  templateUrl: './chars-left.component.html',
  styleUrl: './chars-left.component.scss'
})
export class CharsLeftComponent {
  public readonly maxLength = input.required<number>();
  public readonly maxLengthThreshold = input(10);
  public readonly charsLeft = input.required<number>();
  public readonly charsLeftThreshold = input<number | null>(null);
  public readonly isFull = computed(() => this.charsLeft() <= 0);

  public readonly show = computed(
    () => this.charsLeftThreshold() === null && this.maxLength() >= this.maxLengthThreshold()
  );
}
